import React from "react"
import Card from "@material-ui/core/Card"
import CardActionArea from "@material-ui/core/CardActionArea"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import Typography from "@material-ui/core/Typography"
import Box from "@material-ui/core/Box"
import Divider from "@material-ui/core/Divider"
import ShareButtons from "../ShareButtons"
import { navigate, useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"


const PostCard = props => {

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `
  )

  return (
    <Card
      className={"sec-background"}
      style={{
        borderRadius: 9,
        boxShadow: "0 2px 3px 0 rgba(0,0,0,.10)",
      }}
    >
      <CardActionArea
        onClick={event => {
          event.preventDefault()
          navigate(props.to)
        }}
      >
        <Image
          fluid={props.image}
          alt={"Post thumbnail"}
          style={{ width: "100%", margin: 0, maxHeight: "13rem" }}
          title={props.title}
        />

        <CardContent>
          <Box style={{ display: "flex", justifyContent: "space-between" }} className={"text-primary"}>
            <Typography gutterBottom variant="caption" component="h2">
              {props.date}
            </Typography>

            <Typography gutterBottom variant="caption" component="h2">
              {`${props.timeToRead} min Read`}
            </Typography>
          </Box>

          <Box
            style={{
              lineHeight: "24px",
              minHeight: 40,
            }}
            className={"text-primary"}
          >
            <Typography variant="h3"
              style={{
                margin: 0,
                marginBottom: 10,
                marginTop: 10,
                fontSize: 20,
              }}
            >
              {props.title}
            </Typography>
          </Box>

          <Box>
            <Typography
              variant="body1"
              style={{ margin: 0, marginBottom: 5 }}
              dangerouslySetInnerHTML={{
                __html: props.html,
              }}
            />
          </Box>
        </CardContent>
      </CardActionArea>

      <Divider />

      <CardActions>
        <ShareButtons
          url={site.siteMetadata.siteUrl + "/" + props.to}
          title={props.title}
        />
      </CardActions>
    </Card>
  )
}

export default PostCard
